<template>
    <div class="popup-wrapper">
        <div class="popup-wrapper--container">
            <div class="popup popup-medium">
                <div class="popup--close" @click="$emit('closeEvaluationPopup', false)">
                    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M5 5.0625L10 10.0625L5 15.0625" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M15 5.0625L10 10.0625L15 15.0625" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </div>

                <div class="popup--header">
                    Ako sa vám páči tento titul?
                </div>

                <div class="popup--body">
                    <div class="form">
                        <div class="form--box box-span-2">
                            <div class="add-evaluation add-evaluation-popup">
                                <div class="add-evaluation--rating" :class="evaluationMarkHover ? `mark-hover-${evaluationMarkHover}` : `mark-${evaluation.grade}`">
                                    <div class="add-evaluation--rating--box" v-for="(rating, index) in ratings" :key="index" @click="selectEvaluationMark( rating )" @mouseenter="evaluationMarkHover = rating" @mouseleave="evaluationMarkHover = null">
                                        <EvaluationStar />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="form--box box-span-2">
                            <label class="form-label" :class="{'form-label-error' : errors && errors.title}">
                                <h4>Názov recenzie</h4>

                                <input class="form-input" type="text" v-model="evaluation.title" placeholder="">
                                
                                <div v-if="errors && errors.title" class="form-error">
                                    {{ errors.title[0] }}
                                </div>
                            </label>
                        </div>

                        <div class="form--box box-span-2">
                            <label class="form-label" :class="{'form-label-error' : errors && errors.text}">
                                <h4>Recenzia</h4>

                                <textarea class="form-input" rows="4" v-model="evaluation.text" placeholder=""></textarea>
                                
                                <div v-if="errors && errors.text" class="form-error">
                                    {{ errors.text[0] }}
                                </div>
                            </label>
                        </div>

                        <div class="form--box box-span-2">
                            <label class="form-label form-label-checkbox">
                                <input type="checkbox" class="checkbox" v-model="evaluation.spoiler">
                                <p>Recenzia prezrádza časti deja</p>
                            </label>
                        </div>

                        <div class="form--box">
                            <label class="form-label" :class="{'form-label-error' : errors && errors.name}">
                                <h4>Meno *</h4>

                                <input class="form-input" type="text" v-model="evaluation.name" placeholder="">
                                
                                <div v-if="errors && errors.name" class="form-error">
                                    {{ errors.name[0] }}
                                </div>
                            </label>
                        </div>

                        <div class="form--box">
                            <label class="form-label" :class="{'form-label-error' : errors && errors.email}">
                                <h4>E-mail *</h4>

                                <input class="form-input" type="email" v-model="evaluation.email" placeholder="">
                                
                                <div v-if="errors && errors.email" class="form-error">
                                    {{ errors.email[0] }}
                                </div>
                            </label>
                        </div>

                        <div class="form--box box-span-2">
                            <label class="form-label form-label-checkbox" :class="{'form-label-error' : errors && errors.approvals}">
                                <input type="checkbox" class="checkbox" v-model="evaluation.approvals">
                                <p>Súhlasím so spracovaním <a href="#">osobných údajov</a> a <a href="#">podmienkami uverejnenia recenzií</a></p>
                            </label>
                        </div>
                    </div>
                </div>

                <div class="popup--footer">
                    <span class="btn btn-action-blue btn-padding-medium" @click="store()">Pridať hodnotenie</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import EvaluationStar from '../product-evaluations/EvaluationStar'

    export default {
        components: {
            EvaluationStar
        },
        emits: ['close-evaluation-popup'],
        props: {
            product_id: {
                type: Number
            },
            user: {
                type: Object
            },
            evaluationMark: {
                type: Number
            }
        },
        data() {
            return {
                ratings: [1, 2, 3, 4, 5],
                evaluationMarkHover: null,
                evaluation: {
                    name: this.user && this.user.delivery_address ? this.user.delivery_address.firstname : "",
                    email: this.user ? this.user.email : "",
                    product_id: this.product_id,
                    title: "",
                    text: "",
                    grade: this.evaluationMark,
                    spoiler: false,
                    approvals: false
                },
                errors: null
            }
        },
        methods: {
            selectEvaluationMark( rating ) {
                this.evaluation.grade !== rating ? this.evaluation.grade = rating : this.evaluation.grade = 0
            },
            store() {
                if ( this.evaluation.grade === 0 && !confirm('Tento titul ste ohodnotili 0 hviezdami, chcete pokračovať?') ) return
                
                axios.post('/api/shop/evaluation/store', this.evaluation)
                .then( response => { 
                    this.$emit('closeEvaluationPopup', true)
                }).catch( errors => { this.errors = errors.response.data.errors })
            }
        },
    }
</script>